// Spinner Component
const Spinner = () => (
    <div className='profile-spinner-container'>
        <div className='centered-content'>
            <div className="profile-spinner-wrapper">
                <div className="profile-spinner"></div>
            </div>
        </div>
    </div>
);

export default Spinner;
